import React, { useContext, useEffect } from "react";
import { Row, Col, Button } from "react-bootstrap";
import { Link } from "react-router-dom";

import {
  CrmModule,
  LeadsManagementModule,
  CouponsManagementModule,
  OrdersManagementModule,
  RetailPosModule,
  ReportsModule,
  AccountingModule,
  HrmModule,
  DeliveryManagementModule,
  InventoryModule,
  PurchasesModule,
  PackagingManagementModule,
  DigitalCatalogModule,
  QuoteManagementModule,
  ECommerceB2CModule,
  ECommerceModule,
  ProductServiceModule,
  ServiceBookingModule,
  DemoButton,
  SalesOrderModule,
  ECommerceB2BModule,
} from "./CommonModules";

import CartContext from "./CartContext";

export function CrmSales() {
  const context = useContext(CartContext);

  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  if (!context || (context.EcSettings && context.EcSettings.length === 0)) {
    return null;
  }

  const base = context.GetEcSettingValueByName("StorageBlobImageUrl");

  const getCrmProductType = () => {
    const pt = context.ProductType || {};
    return (
      pt.CRM || pt.CRM_SALES || pt.Sales_CRM || pt.ECommerce || pt.ERP || null
    );
  };

  const handleTryNow = () => {
    const { userData, ShowUserLoginNew, prods, SetSelectedProduct } = context;
    if (!userData || userData.loginStatus !== "active") {
      ShowUserLoginNew(true);
      return;
    }

    const targetType = getCrmProductType();
    if (targetType && prods && prods.length) {
      const selected = prods.find((p) => p.productType === targetType);
      if (selected) {
        SetSelectedProduct(selected);
        return;
      }
    }

    if (typeof context.HandleTryNowButtonClick === "function") {
      context.HandleTryNowButtonClick(targetType);
    }
  };

  return (
    <>
      {/* Hero / Marketing Section */}
      <section className="hero container-fluid py-5 bg-white" id="crmSection">
        <div className="container">
          <div className="row align-items-center gy-4">
            <div className="col-lg-7">
              <span className="badge-sub">CRM & Sales • Customer-first</span>
              <h1 className="display-5 fw-bold mt-3">
                CRM & Sales — convert more leads, close faster and build lasting
                customers.
              </h1>
              <p className="lead text-muted mb-4">
                One platform to capture leads, manage quotes, run marketing
                campaigns, and streamline order-to-cash with integrated customer
                service and analytics.
              </p>

              <p className="mb-3">
                <strong>Why choose this CRM?</strong>
              </p>

              <div className="row g-3">
                <div className="col-sm-6">
                  <div className="d-flex gap-3 align-items-start">
                    <div className="feature-icon">
                      <i className="fa-solid fa-magnet" />
                    </div>
                    <div>
                      <h6 className="mb-1">Lead Capture</h6>
                      <small className="text-muted">
                        Collect leads from web forms, channels & integrations.
                      </small>
                    </div>
                  </div>
                </div>

                <div className="col-sm-6">
                  <div className="d-flex gap-3 align-items-start">
                    <div className="feature-icon">
                      <i className="fa-solid fa-file-signature" />
                    </div>
                    <div>
                      <h6 className="mb-1">Quotes & Orders</h6>
                      <small className="text-muted">
                        Quick quotes, approval flows and easy conversion to
                        orders.
                      </small>
                    </div>
                  </div>
                </div>

                <div className="col-sm-6">
                  <div className="d-flex gap-3 align-items-start">
                    <div className="feature-icon">
                      <i className="fa-solid fa-bullhorn" />
                    </div>
                    <div>
                      <h6 className="mb-1">Marketing Automation</h6>
                      <small className="text-muted">
                        Campaigns, coupons and customer segmentation.
                      </small>
                    </div>
                  </div>
                </div>

                <div className="col-sm-6">
                  <div className="d-flex gap-3 align-items-start">
                    <div className="feature-icon">
                      <i className="fa-solid fa-chart-simple" />
                    </div>
                    <div>
                      <h6 className="mb-1">Sales Analytics</h6>
                      <small className="text-muted">
                        Pipeline and performance dashboards for better
                        forecasts.
                      </small>
                    </div>
                  </div>
                </div>
              </div>

              <div className="mt-4">
                {/* <Button
                  variant="light"
                  size="lg"
                  className="me-2"
                  onClick={handleTryNow}
                >
                  <i className="fa-solid fa-play me-2" /> Book a demo +91-98805
                  82728
                </Button> */}
                <Row>
                  <Col>
                    <DemoButton></DemoButton>
                  </Col>
                  <Col>
                    <Button
                      variant="primary"
                      size="lg"
                      as={Link}
                      to="/Checkout"
                      onClick={handleTryNow}
                    >
                      <i className="fa-solid fa-flask me-2" /> Start free trial
                    </Button>
                  </Col>
                </Row>
              </div>
            </div>

            <div className="col-lg-5">
              <div className="card card-feature p-4">
                <div className="card-body">
                  <h5 className="card-title mb-3">Core CRM capabilities</h5>
                  <div className="row">
                    <div className="col-6 mb-3">
                      <i className="fa-solid fa-user-plus fa-lg me-2" />
                      <strong>Lead Management</strong>
                      <div className="text-muted small">
                        Capture, score & route leads.
                      </div>
                    </div>
                    <div className="col-6 mb-3">
                      <i className="fa-solid fa-file-lines fa-lg me-2" />
                      <strong>Quotes & Orders</strong>
                      <div className="text-muted small">
                        Fast quoting & order conversion.
                      </div>
                    </div>
                    <div className="col-6 mb-3">
                      <i className="fa-solid fa-bullhorn fa-lg me-2" />
                      <strong>Marketing</strong>
                      <div className="text-muted small">
                        Segmentation, campaigns & coupons.
                      </div>
                    </div>
                    <div className="col-6 mb-3">
                      <i className="fa-solid fa-headset fa-lg me-2" />
                      <strong>Service</strong>
                      <div className="text-muted small">
                        Tickets, SLA & field service integration.
                      </div>
                    </div>
                    <div className="col-6 mb-3">
                      <i className="fa-solid fa-cart-shopping fa-lg me-2" />
                      <strong>Sales</strong>
                      <div className="text-muted small">
                        Order processing & omnichannel checkout.
                      </div>
                    </div>
                    <div className="col-6 mb-3">
                      <i className="fa-solid fa-chart-line fa-lg me-2" />
                      <strong>Analytics</strong>
                      <div className="text-muted small">
                        Pipeline reports & revenue forecasting.
                      </div>
                    </div>
                  </div>

                  <div className="mt-3">
                    {/* <Button
                      variant="primary"
                      size="sm"
                      as={Link}
                      to="#features"
                    >
                      See full feature list
                    </Button> */}
                    {/* <Button
                      variant="outline-secondary"
                      size="sm"
                      as={Link}
                      to="#contact"
                      className="ms-2"
                    >
                      Contact sales
                    </Button> */}
                  </div>
                </div>
              </div>
            </div>

            {/* Short description */}
            <div className="col-12 mt-4">
              <div>
                Our CRM & Sales module helps sales teams capture more leads,
                close deals faster, and build lifelong customers by combining
                marketing automation, quoting, and integrated service — all tied
                into your accounts and fulfillment systems.
              </div>
            </div>

            {/* Demo / product video */}
            <div className="col-lg-12 mb-lg-5 py-5">
              {/* <video
                controls
                height="400px"
                autoPlay
                muted
                loop
                width="100%"
                aria-label="CRM & Sales demo video"
              >
                <source src={base + "CrmSalesVideo.mp4"} type="video/mp4" />
                Your browser does not support the video tag.
              </video> */}
              <img
                className="w-100"
                src={base + "carousel3.png"}
                loading="lazy"
              />
            </div>
          </div>

          {/* What we cover */}
          <div className="row mt-5 modules">
            <div className="col-lg-8">
              <div className="card border-0 shadow-sm">
                <div className="card-body">
                  <h4 className="mb-3">What we cover</h4>
                  <div className="row g-3">
                    <div className="col-md-6">
                      <ul className="list-unstyled">
                        <li>
                          <strong>Lead capture & routing:</strong> web forms,
                          channels & auto-assignment.
                        </li>
                        <li>
                          <strong>Quotes & approvals:</strong> configurable
                          templates & discounting rules.
                        </li>
                        <li>
                          <strong>Campaigns & coupons:</strong> email, SMS &
                          promo lifecycle management.
                        </li>
                        <li>
                          <strong>Pipeline & forecasting:</strong> deal stages,
                          scoring and revenue forecasting.
                        </li>
                      </ul>
                    </div>
                    <div className="col-md-6">
                      <ul className="list-unstyled">
                        <li>
                          <strong>Order management:</strong> convert quotes to
                          orders, invoicing & fulfillment handoffs.
                        </li>
                        <li>
                          <strong>Customer service:</strong> tickets, SLA and
                          field service integration.
                        </li>
                        <li>
                          <strong>Integrations:</strong> accounting, marketing
                          tools and ecommerce channels.
                        </li>
                        <li>
                          <strong>Reports:</strong> sales velocity, rep
                          performance and campaign ROI.
                        </li>
                      </ul>
                    </div>
                  </div>
                </div>
              </div>
            </div>

            {/* CTA and trusted badges */}
            <div className="col-lg-4">
              <div className="cta-strip text-center p-4 rounded">
                <h5 className="mb-2">Start converting more leads</h5>
                <p className="mb-3 small text-muted">
                  Book a demo and see how our CRM accelerates your pipeline and
                  improves win rates.
                </p>
                {/* <Button
                  variant="light"
                  size="sm"
                  as={Link}
                  to="#demo"
                  className="me-2"
                  onClick={handleTryNow}
                >
                  <i className="fa-solid fa-calendar-check me-2" /> Book a demo
                  +91-98805 82728
                </Button> */}
                {/* <Button
                  variant="light"
                  size="sm"
                  as={Link}
                  to="/Checkout"
                  onClick={handleTryNow}
                >
                  <i className="fa-regular fa-clock me-2" /> Start free trial
                </Button> */}
                <DemoButton></DemoButton>
              </div>

              <div className="card mt-3 border-0">
                <div className="card-body small text-muted">
                  <strong>Trusted by:</strong>
                  <div className="mt-2 d-flex gap-2 flex-wrap">
                    <span className="badge bg-light text-dark">Retail</span>
                    <span className="badge bg-light text-dark">Services</span>
                    <span className="badge bg-light text-dark">
                      Manufacturing
                    </span>
                  </div>
                </div>
              </div>
            </div>
          </div>

          {/* Footer CTA */}
          <div className="row mt-5">
            <div className="col-12 text-center">
              <p className="text-muted small mb-2">
                30-minute demo, no obligation — see CRM in action.
              </p>
              {/* <Button
                variant="outline-primary"
                size="lg"
                className="me-2"
                onClick={handleTryNow}
              >
                Book a demo +91-98805 82728
              </Button>
              <Button variant="primary" size="lg" as={Link} to="#contact">
                Contact sales
              </Button> */}
              <DemoButton></DemoButton>
            </div>
          </div>
        </div>
      </section>

      {/* CRM Modules Section */}
      <section className="container my-5">
        <h5 className="display-6 text-dark mb-4 border-start border-5 border-primary ps-3 py-5">
          Explore CRM & Sales Modules That Drive Revenue
        </h5>

        <Row className="g-3">
          {[
            LeadsManagementModule,
            QuoteManagementModule,
            SalesOrderModule,
            CrmModule,
            CouponsManagementModule,
            DigitalCatalogModule,
            PurchasesModule,
            InventoryModule,
            RetailPosModule,
            ECommerceB2CModule,
            ECommerceB2BModule,
            ProductServiceModule,
            OrdersManagementModule,
            PackagingManagementModule,
            DeliveryManagementModule,
            AccountingModule,
            // HrmModule,
            ReportsModule,
          ].map((Module, index) => (
            <Col md={6} lg={6} key={index}>
              <div className="bg-light p-3 rounded shadow-sm h-100 hover-shadow">
                <Module />
              </div>
            </Col>
          ))}
        </Row>
      </section>
    </>
  );
}

export default CrmSales;

/* Optional reuseable FeatureSection if needed elsewhere */
export const FeatureSection = ({ title, items }) => (
  <div className="mb-4">
    <Row>
      {items.map((item, idx) => (
        <Col md={6} key={idx}>
          <li className="mb-2">{item}</li>
        </Col>
      ))}
    </Row>
  </div>
);
